const ca = {
	"By using this chat, you agree to our terms and privacy policy.": "En utilitzar aquest xat, acceptes els nostres termes i la nostra política de privacitat.",
	"Type a reply...": "Escriu una resposta..."
};

export { ca as default };
//# sourceMappingURL=ca.Br8YdOfJ.js.map
